function Stars() {
  return (
    <div className="flex items-center gap-0.5">
      {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>)}
    </div>
  );
}

const testimonials = [
  {
    text: "I needed my passport renewed quickly for a business trip to Mexico from Casper. The Denver agency had a 3-week wait. Fast Passport Center had it back in 8 days — exactly as promised. Incredible service.",
    name: "Jason M.",
    location: "Casper, WY",
    service: "Renewal",
  },
  {
    text: "Lost my passport a week before a family cruise. FPC was calm, professional, and walked me through the emergency replacement process. Got it in 4 days. I couldn't believe it worked that fast.",
    name: "Theresa W.",
    location: "Natrona County, WY",
    service: "Lost Passport",
  },
  {
    text: "Our family of four all needed passports renewed before a Europe trip. FPC handled all four simultaneously and kept us updated every step of the way. Smooth and easy — highly recommend.",
    name: "David & Lisa P.",
    location: "Casper, WY",
    service: "Family Renewal",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Casper Area Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Casper and Natrona County travelers who trusted Fast Passport Center to handle their passport applications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}